module.exports = __webpack_public_path__ + "img/vertical_6_4_5012.e6dd2f18.png";